import api from './authService';

export const sitePageService = {
  publicIndex: async () => {
    const response = await api.get('/site-pages/public');
    return response.data;
  },
  adminIndex: async () => {
    const response = await api.get('/admin/site-pages');
    return response.data;
  },
  save: async (slug, content) => {
    const response = await api.put(`/admin/site-pages/${slug}`, { content });
    return response.data;
  },
  upload: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/admin/site-pages/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
